<template>
  <div>
  <CCard>
    <CCardBody>
      <div class="row">
          <div class="col-4">
            <div class="form-group">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Search"
                style="border-radius: 3rem"
              ></b-form-input>
            </div>
          </div>
        </div>

          <b-table
          class="myTable"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          show-empty
               sort-icon-left
      responsive="sm"
    >

    </b-table>
            <div class="mat-table__bottom">
          <span style="margin-right: 20px; margin-bottom: 15px">
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
            ></b-form-select>
          </span>
          <span class="">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              pills
            ></b-pagination>
          </span>
        </div>

    </CCardBody>
  </CCard>

</div>

</template>
<script>
import firebase from "firebase";
import SelectTable from "../tables/SelectTable";
import moment from "moment";
import WidgetsBrand from '../widgets/WidgetsBrand'
import WidgetsDropdown from '../widgets/WidgetsDropdown'
import { CChartBar } from '@coreui/vue-chartjs'
import CTableWrapper from '../tables/Table.vue'
import usersData from '../users/UsersData'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)


export default {
  name: "customer",
  components: {
        WidgetsBrand,
    WidgetsDropdown,CChartBar,CTableWrapper

  },  
  data: ()=>{
    return {
            datavalue: "",
            filter:'',
      items:[],
            totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],

    fields: [
          { key: 'name', label: 'Name', sortable: true,  },
          { key: 'phone', label: 'Phone', sortable: true },
          { key: 'last', label: 'Last Visit', sortable: true},
          { key: 'lastorder', label: 'Last purchase Value',class:'text-center'},
                    { key: 'totalorder', label: 'Total purchase Value',class:'text-center'},

          { key: 'visit', label: 'Total Visit',class:'text-center'},
            ],
    }
  },
  methods:{
     shuffleArray (array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1))
        let temp = array[i]
        array[i] = array[j]
        array[j] = temp
      }
      return array
    },

    getShuffledUsersData () {
      return this.shuffleArray(usersData.slice(0))
    },
    getCustomerList() {
      const db = firebase.firestore();
      let temp = 0;
      let self = this;
      db.collection("customer")
              .where("StoreId", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log(doc.data())
              this.datavalue = {
                name:doc.data().nickname,
                phone:doc.data().phone,
                visit:doc.data().totalVisit,
                last: moment(
                  new Date(doc.data().lastSeen.seconds * 1000)
                ).format("MM-DD-YYYY HH:MM:A"),
                lastorder:Math.round(doc.data().lastorder),
                totalorder:Math.round(doc.data().totalorder)
              };
              // this.datavalue["id"] = temp;
              // temp = temp + 1;
              this.items.push(this.datavalue);
                                  this.totalRows=this.items.length;

console.log(this.datavalue)

          });
          console.log("over")
        })
        .catch((err) => {
          console.log(err);
        });
    },

  },
  created(){
this.getCustomerList();
  }
}
</script>

<style>
.myTable thead {
  font-weight: 600;
  font-family:'Montserrat';
  font-size: 18px;
  color: #3B4859;
  }
  .custom-select-sm {
  font-family:'Montserrat';

  }
.myTable  td{
  color: #3B4859;
  font-family: 'Assistant';
  font-weight:500;
  font-size:14px;
  padding-top:2px;
  padding-bottom: 2px;
}
.mat-table__bottom {
    display: flex;
    align-items: center;
    justify-content:  flex-end;
}
.b-pagination-pills .page-item .page-link {
  color:#3B4859;
  border: transparent;
  font-family: 'Montserrat';
  font-size: 12px;
  font-weight: 400;

}
.page-item.active .page-link {
    font-family: 'Montserrat';
font-size: 12px;
  font-weight: 400;
  background: #ff0000;
  color:#fff;
  border:#ff0000
}
.table td{
  
  padding: 5px!important;
    vertical-align:0;
    border-top: none;
    border-top-color: none;
}</style>
